import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const MetaService = {

    getTemplates: (account_id, status = '') => {
        return HTTP.get<any, any>(`${API_ENDPOINT.META_SERVICES}templates`, { params: { account_id, status } });
    },

    syncTemplates: (account_id ) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.META_SERVICES}templates/sync-templates`, { account_id } );
    },

    saveTemplate: ( template ) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.META_SERVICES}templates/save`,  template  );
    },

    uploadMedia: (data: FormData) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.META_SERVICES}templates/upload-media`, data);
    },


    delete: ( account_id, template_id, meta_id, name ) => {
        return HTTP.delete<any, any>(`${API_ENDPOINT.META_SERVICES}templates/delete`,  { data: { account_id, template_id, meta_id, name } } );
    },

    setMedia: (data: FormData) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.META_SERVICES}templates/set-media`, data);
    },

    getTemplatesTriggers: (account_id, status = '', type_template = '') => {
        return HTTP.get<any, any>(`${API_ENDPOINT.META_SERVICES}templates`, { params: { account_id, status, type_template } });
    },

}